import axios from '../../axios';

export default {
  namespaced: true,
  state: {
    allLists: null,
    currentList: null,
  },
  getters: {
    getAllLists: (state) => {
      if (state.allLists) {
        return state.allLists;
      }
    },
    getListByURL: (state, getters) => (url) => {
      if (state.allLists) {
        return state.allLists.find((l) => l.url === url);
      }
    },
    getCurrentList: (state) => {
      if (state.currentList) {
        return state.currentList;
      }
    },
  },
  mutations: {
    setAllLists(state, lists) {
      state.allLists = lists;
    },
    setCurrentList(state, list) {
      state.currentList = list;
    },
  },
  actions: {
    // fetchAllLists({
    //  commit, dispatch, getters, rootGetters,
    // }) {
    //  axios.get(`/core/lists/live/lang/${rootGetters['pages/currentLang']}`)
    //    .then((res) => {
    //      commit('setAllLists', res.data);
    //    })
    //    .catch((error) => console.log(error));
    // },
    fetchListById({
      commit, state, dispatch, getters, rootGetters,
    }, data) {
      return new Promise((resolve, reject) => {
        if (!getters.getCurrentList || (data && data.forceReload)) {
          axios.get(`/core/lists/live/${data.id}/lang/${rootGetters['pages/currentLang']}`)
            .then((res) => {
              commit('setCurrentList', res.data);
              resolve(res.data);
            });
        } else {
          resolve(getters.getCurrentList);
        }
      });
    },
  },
};
